// extracted by mini-css-extract-plugin
export default {"grey":"style_grey__WFw54"};